
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Database } from "@/integrations/supabase/types";

export type Fund = Database['public']['Tables']['funds']['Row'] & {
  fund_performance: {
    date: string;
    performance_value: number;
    metric_name: string;
    frequency: string;
  }[];
  company: {
    id: string;
    fund_company_name: string;
    website_url: string;
    description: string;
    logo_url: string;
    fund_contacts: {
      id: string;
      full_name: string | null;
      title: string | null;
      work_email: string | null;
      linkedin_profile: string | null;
      phone_number: string | null;
      key_contact: boolean;
      avatar_url: string | null;
    }[];
  } | null;
};

export const useFundData = (fundId: string | undefined) => {
  return useQuery({
    queryKey: ['fund', fundId],
    queryFn: async () => {
      const qb = supabase
        .from('funds')
        .select(`
          *,
          fund_performance (
            date,
            performance_value,
            metric_name,
            frequency
          ),
          company:fund_companies (
            id,
            fund_company_name,
            website_url,
            description,
            logo_url,
            fund_contacts!inner (
              id,
              full_name,
              title,
              work_email,
              linkedin_profile,
              phone_number,
              key_contact,
              avatar_url
            )
          )
        `) as any;

      const { data, error } = await qb.eq('id', fundId).single();

      if (error) throw error;
      console.log('Fetched fund data:', data);
      return data as unknown as Fund;
    },
    staleTime: 0, // Data is considered stale immediately
    gcTime: 5 * 60 * 1000, // Keep unused data in cache for 5 minutes
    refetchOnWindowFocus: true, // Refetch when window regains focus
    refetchOnMount: true, // Refetch on component mount
    refetchOnReconnect: true, // Refetch when reconnecting
    retry: 2, // Retry failed requests twice
  });
};
